import { useQuery } from '@tanstack/react-query';
import { InfoField } from '~/shared/InfoField';
import { getPatientOptions } from '@generated';
import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { useChart } from '~/features/admissions/charts/ChartContext';

const today = new Date();

export function PatientKeyFields() {
	const { patientId } = useChart();
	const { data: patient, isLoading } = useQuery(getPatientOptions(patientId!));
	if (isLoading || !patient) {
		return null;
	}

	const calculateAge = (birthDate: Date) => {
		let age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();
		if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age.toString();
	};

	return (
		<Section header={<SectionTitle title="Patient Overview" />}>
			<div className="grid grid-cols-3 gap-4 p-6">
				<InfoField label="Gender" value={patient.genderLabel} />
				<InfoField label="Birth Date" value={new Date(patient.dateOfBirth).toLocaleDateString()} />
				<InfoField label="Age" value={calculateAge(patient.dateOfBirth)} />
			</div>
		</Section>
	);
}
